<div class="input-el" data-testid="avatar-container">
  <label for="avatarimg" name="avatar_btn" data-testid="avatar-btn">
    @if (avatarImg() != null) {
      <div class="modify-avatar" (click)="deleteAvatarImg(); $event.preventDefault();" data-testid="avatar-delete-btn">
        <img src="assets/icons/dark/ui/cancel_icon.svg" />
      </div>
    }

    @if (avatarImg() == null) {
      <div class="modify-avatar">
        <div class="plus-icon">+</div>
      </div>
    }

    <div class="avatar">
      @if (!avatarImg() && !avatarLoading()) {
        <img [src]="'/assets/icons/dark/ui/user_icon.svg'"
          alt="Default avatar" />
      }

      @if (avatarLoading()) {
        <div class="avatar-loading"></div>
      }

      @if (avatarImg() && !avatarLoading()) {
        <div class="avatar-preview"
        [style.background-image]="'url(' + avatarImg() + ')'"></div>
      }
    </div>
  </label>
</div>

<input #avatarInput style="display: none;" name="avatar-upload" type="file" id="avatarimg"
  data-testid="avatar-upload-input"
  (change)="onAvatarChange($event)"
  accept="image/png,image/jpeg,image/jpg,image/webp,image/avif,image/gif,image/bmp,.heic,.heif" />

  @if (invalidImgType()) {
    <h6 class="invalid invalid-img">
      {{ languageService.languageJSON.AccountDialog_Avatar_Error_Type }}
    </h6>
  }
  @if (invalidImgSize()) {
    <h6 class="invalid invalid-img">
      {{ languageService.languageJSON.AccountDialog_Avatar_Error_Size }}
    </h6>
  }